// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { shareNodes16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-share-nodes': IconShareNodes;
    }
}

/**
 * The icon component for the 'shareNodes' icon
 */
export class IconShareNodes extends IconSvg {
    public constructor() {
        super(shareNodes16X16);
    }
}

registerIconSvg('icon-share-nodes', IconShareNodes);
export const iconShareNodesTag = 'nimble-icon-share-nodes';
